import script from "./PageSiteMap.vue?vue&type=script&setup=true&lang=js"
export * from "./PageSiteMap.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__